'use strict';

var NotificationModalDirective = function NotificationModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: require('../templates/notification-modal.html'),
    scope: {
      visible: '=',
      title: '@',
      content: '@'
    },
    link: function link($scope, $element) {
      $scope.$watch('visible', function () {
        $element.modal($scope.visible ? 'show' : 'hide');
      });
    }
  };
};
NotificationModalDirective.$inject = [];
module.exports = NotificationModalDirective;